'use client';

import type { PaginatedProduct } from '@dealerportal/common';
import type { FC } from 'react';
import ProductCardSkeleton from '../../../../../ui-components/src/lib/skeletons/ProductCardSkeleton';
import { useCatalogContext } from '../../Contexts/CatalogContext';
import { ProductCard } from '../ProductCard/ProductCard';
import { ProductsNotFound } from './ProductsNotFound';

interface Props {
  showSwatches?: boolean;
  initialProducts?: PaginatedProduct[];
}

export const ProductResults: FC<Props> = ({
  showSwatches = false,
  initialProducts,
}: Props) => {
  const { products: contextProducts, settings } = useCatalogContext();
  const products = contextProducts ?? initialProducts;
  if (products?.length === 0) {
    return <ProductsNotFound />;
  }

  return (
    <div className="srp__listings ui-grid md:ui-grid-cols-2 lg:ui-grid-cols-3 ui-gap-4">
      {products === undefined ? (
        <>
          <ProductCardSkeleton />
          <ProductCardSkeleton />
          <ProductCardSkeleton />
          <ProductCardSkeleton />
          <ProductCardSkeleton />
          <ProductCardSkeleton />
        </>
      ) : (
        products.map((product, _index) => (
          <ProductCard
            key={product.UPID}
            product={product}
            showSwatches={showSwatches}
            disableOrderSample={settings?.hideOrderSampleButton}
            hidePricing={settings?.hidePricing}
          />
        ))
      )}
    </div>
  );
};
